export const MEMBER_NUMBER_DEFAULTS = {
  mode: "automatic",
  format: "prefix_sequential",
  prefix: "",
  padding: 4,
  alphanumeric_length: 6,
};

export const memberNumberSettingsFromApi = (data) => ({
  ...MEMBER_NUMBER_DEFAULTS,
  ...(data?.member_number_settings || {}),
});

export const isManualMemberNumbers = (settings) => settings?.mode === "manual";

export const showFamilyMemberAttach = (settings) =>
  settings?.mode === "automatic" && settings?.format === "sequential_extension";

// Example number for the "Prefijo + secuencia" option, built from the prefix and digits typed.
export const prefixSequenceExample = (settings) => {
  const digits = Math.min(Math.max(Number(settings?.padding) || MEMBER_NUMBER_DEFAULTS.padding, 1), 12);
  return `${settings?.prefix ?? ""}${"1".padStart(digits, "0")}`;
};

const COMPARED_FIELDS = ["mode", "format", "prefix", "padding", "alphanumeric_length"];
export const memberNumberSettingsChanged = (saved, current) =>
  COMPARED_FIELDS.some((field) => String(saved?.[field] ?? "") !== String(current?.[field] ?? ""));
